import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { AuthCard } from "@/components/auth-card";
import { FormField } from "@/components/form-field";
import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { confirmPasswordReset, errorMessage, MIN_PASSWORD_CHARS } from "@/lib/api";
import { passwordProblem } from "@/lib/auth";
import { BackToLogin } from "@/routes/forgot-password";

/** `/passwort-neu?token=…` (AUTH-03): the page behind the e-mailed link. */
export function ResetPasswordPage({ token }: { token: string }) {
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [problem, setProblem] = useState<string | null>(null);
  const mutation = useMutation({ mutationFn: () => confirmPasswordReset(token, password) });

  return (
    <AuthCard title="Neues Passwort" description="Danach bist du überall abgemeldet.">
      {mutation.isSuccess ? (
        <div className="grid gap-4">
          <Alert variant="success">Das Passwort ist geändert. Du kannst dich jetzt anmelden.</Alert>
          <BackToLogin />
        </div>
      ) : (
        <form
          className="grid gap-4"
          onSubmit={(e) => {
            e.preventDefault();
            const found = passwordProblem(password, repeat);
            setProblem(found);
            if (!found) mutation.mutate();
          }}
        >
          {(problem ?? mutation.isError) && (
            <Alert variant="destructive">{problem ?? errorMessage(mutation.error)}</Alert>
          )}
          <FormField
            label="Neues Passwort"
            type="password"
            autoComplete="new-password"
            required
            autoFocus
            hint={`Mindestens ${MIN_PASSWORD_CHARS} Zeichen; ein Satz ist leichter zu merken.`}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <FormField
            label="Wiederholen"
            type="password"
            autoComplete="new-password"
            required
            value={repeat}
            onChange={(e) => setRepeat(e.target.value)}
          />
          <Button type="submit" disabled={mutation.isPending}>
            Passwort setzen
          </Button>
          <BackToLogin />
        </form>
      )}
    </AuthCard>
  );
}
